var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ik-image',{attrs:{"path":_vm.path,"query-parameters":_vm.queryParameters,"transformation":_vm.transformation,"loading":_vm.loading,"height":_vm.height,"width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }